export default __webpack_public_path__ + "static/JimMcMahon-6a243b4c963653097a5049af5386e569.jpg";